import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 90000 });

export const STAGES = [
  { id: "new", label: "New" },
  { id: "researching", label: "Researching" },
  { id: "contacted", label: "Contacted" },
  { id: "engaged", label: "Engaged" },
  { id: "negotiating", label: "Negotiating" },
  { id: "won", label: "Won" },
  { id: "lost", label: "Lost" },
  { id: "unsuitable", label: "Unsuitable" },
];

export const getProfile = () => api.get("/profile").then((r) => r.data);
export const updateProfile = (data) => api.put("/profile", data).then((r) => r.data);

export const listLeads = (stage) =>
  api.get("/leads", { params: stage ? { stage } : {} }).then((r) => r.data);
export const getLead = (id) => api.get(`/leads/${id}`).then((r) => r.data);
export const createLead = (data) => api.post("/leads", data).then((r) => r.data);
export const updateLead = (id, data) => api.patch(`/leads/${id}`, data).then((r) => r.data);
export const deleteLead = (id) => api.delete(`/leads/${id}`).then((r) => r.data);

export const discoverLeads = (payload) =>
  api.post("/leads/discover", payload).then((r) => r.data);
export const generateDraft = (id) =>
  api.post(`/leads/${id}/draft`).then((r) => r.data);
export const generateSequence = (id) =>
  api.post(`/leads/${id}/sequence`).then((r) => r.data);
export const generateLinkedinNote = (id) =>
  api.post(`/leads/${id}/linkedin-note`).then((r) => r.data);
export const sendEmail = (id, payload = {}) =>
  api.post(`/leads/${id}/send`, payload).then((r) => r.data);
export const testSend = () => api.post("/email/test").then((r) => r.data);
export const findEmail = (id) => api.post(`/leads/${id}/find-email`).then((r) => r.data);

export const listActivities = (id) =>
  api.get(`/leads/${id}/activities`).then((r) => r.data);
export const addActivity = (id, data) =>
  api.post(`/leads/${id}/activities`, data).then((r) => r.data);

export const getStats = () => api.get("/stats").then((r) => r.data);
export const verifyAppKey = (key) => api.post("/app/verify", { key }).then((r) => r.data);
export const joinWaitlist = (payload) => api.post("/waitlist", payload).then((r) => r.data);
export const getWaitlistCount = () => api.get("/waitlist/count").then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const adminListWaitlist = (key) =>
  api.get("/admin/waitlist", { headers: { "X-Admin-Key": key } }).then((r) => r.data);
export const adminWaitlistCsvUrl = (key) =>
  `${API}/admin/waitlist.csv?_k=${encodeURIComponent(key)}`;
export const adminListMessages = (key) =>
  api.get("/admin/messages", { headers: { "X-Admin-Key": key } }).then((r) => r.data);
export const adminDeleteMessage = (id, key) =>
  api.delete(`/admin/messages/${id}`, { headers: { "X-Admin-Key": key } }).then((r) => r.data);
